import { render, staticRenderFns } from "./TabelaDirigentes.vue?vue&type=template&id=c1838bd4"
import script from "./TabelaDirigentes.vue?vue&type=script&lang=js"
export * from "./TabelaDirigentes.vue?vue&type=script&lang=js"
import style0 from "./TabelaDirigentes.vue?vue&type=style&index=0&id=c1838bd4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports